<div class="page-content page-fill">
  <div class="card mb-3">
    <div class="card-body">
      <div >
        <button class="btn btn-primary" (click)="printDirectory()">Print Directory</button>
        @if (!readOnly) {
          <button class="btn btn-primary ms-2" (click)="printDirectory('picture')">Print Picture Directory</button>
        }
        <button class="btn btn-primary ms-3" (click)="printHouseholdsReport()">Print Households</button>
        <button class="btn btn-primary ms-2" (click)="printCommitteeReport()">Print Committees</button>
      </div>
      @if (!readOnly) {
        <div class="mt-2">
          <button class="btn btn-primary" (click)="printContactSheet()">Print Council Contact Info</button>
          <button class="btn btn-primary ms-2" (click)="printPrayerSheet()">Print Prayer Sheet</button>
          <button class="btn btn-primary ms-2" (click)="printExitGreeters()">Print Exit Greeters</button>
          <button class="btn btn-primary ms-2" (click)="printCommitteeAssignment()">Print Committee Assignment Request Form</button>
        </div>
      }
      @if (filter) {
        <dx-form [formData]="filter" style="max-width: 400px">
          @if (filter) {
            <dxi-item [label]="{ text: 'Statuses' }">
              <div *dxTemplate>
                <dx-select-box [(value)]="filter.statusId" [items]="statuses" valueExpr="id" displayExpr="name" (onValueChanged)="onValueChanged($event)"></dx-select-box>
              </div>
            </dxi-item>
          }
        </dx-form>
      }
    </div>
  </div>
  <div class="row flex-fill">
    <div class="col-4 flex-fill border-end">
      @if (committees) {
        <div class="grid-fill">
          <dx-data-grid
            #dataGrid
            [dataSource]="committees"
            keyExpr="id"
            [focusedRowEnabled]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="onSelectionChanged($event)"
            >
            <dxi-column dataField="name" caption="Name" [width]="250"></dxi-column>
            <dxo-selection [mode]="'single'"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'"></div>
          </dx-data-grid>
        </div>
      }
    </div>
    <div class="col-8 flex-fill border-end">
      <div class="grid-fill">
        <dx-data-grid #memberGrid [dataSource]="members" keyExpr="id" [focusedRowEnabled]="false" (onToolbarPreparing)="onToolbarPreparing($event)">
          <dxi-column dataField="person.displayName" caption="Name" [width]="175" cellTemplate="linkTemplate"></dxi-column>
          <dxi-column dataField="person.cellPhone" caption="Cell" [width]="125"></dxi-column>
          <dxi-column dataField="person.email" caption="Email" [width]="250"></dxi-column>
          <dxi-column dataField="chair" [width]="60"></dxi-column>
          <dxi-column dataField="clerk" [width]="60"></dxi-column>
          <dxi-column dataField="term" [width]="150"></dxi-column>
          <dxi-column dataField="startDate" [width]="100" [visible]="showHistory"></dxi-column>
          <dxi-column dataField="endDate" [width]="100" [visible]="showHistory"></dxi-column>
          <dxi-column [width]="50"></dxi-column>

          <div *dxTemplate="let cell of 'linkTemplate'">
            <a [routerLink]="" (click)="open(cell.data)">{{ cell.value || "(blank)" }}</a>
          </div>

          <dxo-selection [mode]="'multiple'"></dxo-selection>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="committee-members-grid"></dxo-state-storing>
          <dxo-search-panel [visible]="true"></dxo-search-panel>

          <div *dxTemplate="let data of 'toolbarButtons'">
            <button (click)="addPerson()" class="btn btn-primary" [disabled]="isCouncil" [hidden]="isCouncil || readOnly">Add Member</button>
            <button
              class="btn btn-danger ms-4"
              (click)="remove()"
              [disabled]="memberGrid.instance.getSelectedRowsData().length === 0 || isCouncil"
              [hidden]="isCouncil || readOnly"
              >
              Remove
            </button>
            <button
              class="btn btn-success ms-4"
              (click)="assignRole('Chair')"
              [disabled]="memberGrid.instance.getSelectedRowsData().length !== 1 || isCouncil"
              [hidden]="isCouncil || readOnly"
              >
              Chair
            </button>
            <button
              class="btn btn-success ms-2"
              (click)="assignRole('Clerk')"
              [disabled]="memberGrid.instance.getSelectedRowsData().length !== 1 || isCouncil"
              [hidden]="isCouncil || readOnly"
              >
              Clerk
            </button>
            <button
              class="btn btn-success ms-2"
              (click)="assignDate('Start')"
              [disabled]="memberGrid.instance.getSelectedRowsData().length !== 1 || isCouncil"
              [hidden]="isCouncil || readOnly"
              >
              Start
            </button>
            <button
              class="btn btn-success ms-2"
              (click)="assignDate('End')"
              [disabled]="memberGrid.instance.getSelectedRowsData().length !== 1 || isCouncil"
              [hidden]="isCouncil || readOnly"
              >
              End
            </button>
            <button class="btn btn-danger ms-2" (click)="toggleShowHistory()" [hidden]="readOnly">{{ showHistory ? "Hide History" : "Show History" }}</button>
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (members) {
              <span class="me-2">
                <strong>{{ memberGrid.instance.totalCount() + " items" }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    </div>
  </div>
</div>
